import React from 'react';
import { CsvData } from 'types';
import { replaceSpaceAndCapitalize, searchifyTerm } from 'utility/utility';
import { TextLink } from '@dsg-tech/homefield-react';
import './FooterColumn.scss';

interface ColumnProps {
  column: CsvData;
}

const Column = ({ column }: ColumnProps) => {
  return (
    <div className="footer-column hmf-py-xxlg-l hmf-px-xxlg-m">
      <h3 className="hmf-m-0 hmf-mb-s hmf-body-bold-l hmf-text-transform-uppercase">{column.n}</h3>
      <div className="footer-column-items hmf-display-flex hmf-flex-column hmf-align-items-flex-start">
        {column.col[0]?.cats.map((cat) => (
          <TextLink
            key={`${cat.n}-${cat.u}`}
            href={cat.u}
            variant="group"
            size="small"
            data-em={`Footer_${replaceSpaceAndCapitalize(searchifyTerm(cat.n))}`}>
            {cat.n}
          </TextLink>
        ))}
      </div>
    </div>
  );
};

interface FooterColumnProps {
  columns: CsvData[];
}

const FooterColumn = ({ columns }: FooterColumnProps) => {
  return (
    <section
      data-testid="FooterColumn"
      className="footer-columns hmf-display-none hmf-display-lg-flex hmf-justify-content-around hmf-py-l hmf-px-m hmf-py-xxlg-0 hmf-px-xxlg-0 hmf-my-0 hmf-mx-auto">
      {columns.map((column) => (
        <Column column={column} key={column.n} />
      ))}
    </section>
  );
};

export default FooterColumn;
